import { window } from "global";
import React, { useEffect } from "react";
import { ReactComponent as FullUggLogo } from "../../../svg/logos/ugg-logo-blue.svg";
import Searchbar from "components/Searchbar";
import { ReactComponent as LolLogo } from "svg/League-SelectorLogo.svg";
import { ReactComponent as WowLogo } from "svg/WoW-SelectorLogo.svg";
import { ReactComponent as TftLogo } from "svg/tft-grey-selector-logo.svg";
import { ReactComponent as ValorantLogo } from "svg/valorant-logo.svg";
import GameButton from "./GameButton";
import PromoButton from "./PromoButton";
import { Helmet } from "react-helmet-async";
import { ReactComponent as RaidIcon } from "svg/wow-skull-head.svg";
import { ReactComponent as ClassAndSpecIcon } from "svg/wow-tier-list-icon.svg";
import { ReactComponent as PvPIcon } from "svg/wow-pvp-icon.svg";
import { ReactComponent as MythicKeyIcon } from "svg/wow-mythic-plus-key-icon.svg";
import { ReactComponent as WowTextLogo } from "svg/wow-text-logo.svg";
import { ReactComponent as LeagueSmallLogo } from "svg/lol-logo-filled.svg";
import { ReactComponent as UGGLogo } from "svg/logos/ugg-logo-blue.svg";
import { MediaQuery } from "@outplayed/responsive";
import UAParser from "ua-parser-js";
import { EXPANSION, SEASON } from "lib/wowHelpers";

const parser = new UAParser();
const os = parser.getOS();
const isMac = os?.name?.match(/mac/gi);

const LandingPageContainer = (props) => {
  useEffect(() => {
    window && sessionStorage.removeItem("initial_page");
  }, []);

  const games = [
    {
      logo: <LolLogo />,
      link: "/?utm_source=gs-wow2lol",
      id: "league",
    },
    {
      logo: <ValorantLogo />,
      link: "/val?utm_source=gs-wow2val",
      id: "val",
      showNew: true,
    },
    {
      logo: <WowLogo />,
      link: "/wow?utm_source=gs-wow2wow",
      id: "wow",
    },
    {
      logo: <TftLogo />,
      link: "/tft/comps?utm_source=gs-wow2tft",
      id: "tft",
      showNew: true,
    },
  ];
  const promos = [
    {
      img: <MythicKeyIcon />,
      labelOne: "Mythic+",
      labelTwo: "Tier List",
      link: "/wow/tier-list/dps-rankings",
    },
    {
      img: <RaidIcon />,
      labelOne: "Raiding",
      labelTwo: "Tier List",
      link: "/wow/tier-list/dps-rankings/raid",
    },
    {
      img: <PvPIcon />,
      labelOne: "PvP",
      labelTwo: "Tier List",
      link: "/wow/tier-list/dps-rankings/pvp",
    },
    {
      img: <ClassAndSpecIcon />,
      labelOne: "Classes & Specs",
      labelTwo: "",
      link: "/wow/classes-and-specs",
    },
  ];

  let content = null;
  if (!window) {
    content = null;
  } else {
    content = (
      <React.Fragment>
        <Helmet>
          <title>U.GG: WoW Tier Lists, Rankings, Talents, Builds</title>
          <meta
            name="description"
            content="Better data for smarter insights. U.GG has the best data-driven WoW talents, BIS gear guides and tier lists for every class and spec in Raid, Mythic+, and PvP."
          />
        </Helmet>
        <div className="wow-landing-page-container">
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail>
            <FullUggLogo className="ugg-landing-page-logo" />
            <Searchbar className="landing-page-search-bar-container" isLandingPage />
            <div className="game-switcher">
              {games.map((x, i) => (
                <GameButton key={i} {...x} />
              ))}
            </div>
          </MediaQuery>
          <MediaQuery min="TABLET" max="DESKTOP_LARGE" renderNullOnFail>
            <div className="landing-page-layout-container">
              <div className="left-side">
                <div className="desktop-app-landing-page_header">
                  <img
                    className="ugg-logo"
                    src="https://static.bigbrain.gg/assets/lol/performance_analysis/images/UGG_Logo_Blue_3.svg"
                    alt="U.GG Logo"
                  />
                  <WowTextLogo className="league-logo" />
                </div>
                <div className="large-search search-container">
                  <Searchbar className="landing-page-search-bar-container" isLandingPage />
                </div>
                <div className="regions-and-games">
                  <div className="game-switcher">
                    <a className="big-border" href="https://u.gg?utm_source=gs-wow2lol">
                      <div className="container lol">
                        <div className="game-card lol">
                          <div className="shadow-overlay" />
                          <div className="game-card-gloss" />
                          <img className="text" src="https://static.bigbrain.gg/assets/ugg/icons/LOL-TEXT.png" />
                        </div>
                      </div>
                    </a>
                    <a className="big-border" href="https://u.gg/val?utm_source=gs-wow2val">
                      <div className="new-icon">NEW</div>
                      <div className="container">
                        <div className="game-card val">
                          <div className="shadow-overlay" />
                          <div className="game-card-gloss" />
                          <img className="text" src="https://static.bigbrain.gg/assets/ugg/icons/VAL-TEXT.png" />
                        </div>
                      </div>
                    </a>
                    <a className="big-border" href="https://u.gg/wow?utm_source=gs-wow2wow">
                      {/* <div className="new-icon">NEW</div> */}
                      <div className="container wow">
                        <div className="game-card wow">
                          <div className="shadow-overlay" />
                          <div className="game-card-gloss" />
                          <img className="text" src="https://static.bigbrain.gg/assets/ugg/icons/WOW-TEXT.png" />
                        </div>
                      </div>
                    </a>
                    <a className="big-border" href="https://u.gg/tft/comps?utm_source=gs-wow2tft">
                      <div className="new-icon">SET 13</div>
                      <div className="container tft">
                        <div className="game-card tft">
                          <div className="shadow-overlay" />
                          <div className="game-card-gloss" />
                          <img className="text" src="https://static.bigbrain.gg/assets/ugg/icons/TFT-TEXT.svg" />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="right-side">
                <WoWPromo />
              </div>
            </div>
          </MediaQuery>
          <div className="promos-container">
            {promos.map((x, i) => (
              <PromoButton key={i} {...x} />
            ))}
          </div>
        </div>
      </React.Fragment>
    );
  }

  return <React.Fragment>{content}</React.Fragment>;
};

const WoWPromo = () => {
  return (
    <>
      <div className="promo-text-bar">
        <div className="promo-text">
          Mythic+ and Raid {EXPANSION} S{SEASON}
        </div>
        <a className="download-link" href="/wow/tier-list/dps-rankings?utm_source=promo-home-wow2wow" target="_blank">
          U.GG/WOW
        </a>
      </div>
      <div className="video-container">
        <div className="shadow-overlay" />
        <video autoPlay loop muted>
          <source type="video/webm" src="https://static.bigbrain.gg/wow/assets/videos/ugg-wow-promo-loop.webm" />
        </video>
        <div className="video-overlay">
          <div className="header-with-logos">
            <WowLogo className="wow-logo" />
            <UGGLogo className="ugg-logo" />
            Tier lists, talents, and more
            <div className="new-tag">NEW</div>
          </div>
          <div className="promo-text">Data-driven, always BIS</div>
          <a href="/wow/tier-list/dps-rankings?utm_source=promo-home-wow2wow" target="_blank" className="val-link">
            <div className="download-button not-league">Check out U.GG/WOW</div>
          </a>
        </div>
      </div>
    </>
  );
};

export default LandingPageContainer;
